const state = {
    user: null,
    routers: [],
    shopDesignTemplateId: 0,
};
const mutations = {
    setUser(state, userInfo){
        state.user = userInfo
    },
    setRouters(state, routers){
        state.routers = routers
    },
    setShopDesignTemplateId(state, id){
        state.shopDesignTemplateId = id
    }
};
const actions = {
    setUser({commit}, userInfo){
        commit('setUser', userInfo);
    },
    setRouters({commit}, routers){
        commit('setRouters', routers);
    },
    setShopDesignTemplateId({commit}, id){
        commit('setShopDesignTemplateId', id);
    }
};
const getters = {
    user(state){
        return state.user
    },
    routers(state){
        return state.routers
    },
    shopDesignTemplateId(state){
        return state.shopDesignTemplateId
    }
};

export default {
    namespaced:true,
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/adminUser.js